"use client";
import React, { useEffect, useRef, type JSX } from "react";
import { Drawer } from "@cappelendamm/design-system/react";
import { Menu, Xmark } from "iconoir-react";
import { usePathname } from "next/navigation";

type HeaderDrawerProps = {};

export default function HeaderDrawer({
  children,
  ...rest
}: HeaderDrawerProps & Omit<JSX.IntrinsicElements["button"], "onClick">) {
  const ref = useRef<HTMLDialogElement>(null);
  const pathname = usePathname();

  const closeDrawer = () => {
    if (ref.current) ref.current.close();
    document.body.style.overflow = "";
  };

  useEffect(() => {
    closeDrawer();
  }, [pathname]);

  useEffect(() => {
    // Trigger button is hidden at the `lg` breakpoint (--breakpoint-lg, 1200px) -
    // close the drawer if it's still open when the viewport crosses that point.
    const query = window.matchMedia("(min-width: 1200px)");
    const handleChange = (event: MediaQueryListEvent) => {
      if (event.matches) closeDrawer();
    };
    query.addEventListener("change", handleChange);
    return () => query.removeEventListener("change", handleChange);
  }, []);

  return (
    <>
      <button
        onClick={() => {
          if (ref.current) ref.current.showModal();
          document.body.style.overflow = "hidden";
        }}
        {...rest}
      >
        <Menu width={24} height={24} />
      </button>
      <Drawer
        variant="left"
        ref={ref}
        className="fixed overflow-y-auto pt-20 pb-0"
      >
        <button
          className="absolute top-4 right-4 flex h-12 w-12 items-center justify-center rounded-full bg-surface-150"
          onClick={closeDrawer}
          aria-label="Lukk"
        >
          <Xmark width={24} height={24} />
        </button>
        {children}
      </Drawer>
    </>
  );
}
